import { SettingsNavigation } from '@/components/SettingsNavigation';
import { Heading } from '@televet/kibble-ui/Heading';
import { Flex } from '@televet/kibble-ui/chakra';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Flex
      className="SettingsContainer"
      data-testid="settings-container"
      flex="1 1 auto"
      direction="column"
      align="center"
      h="100%"
      overflow="hidden"
      bg="background.subtle"
    >
      <Flex className="SettingsContainer__Centered" flex="1 1 auto" w="100%" h="100%">
        <Flex
          className="SettingsContainer__Navigation"
          flex="0 0 auto"
          w="240px"
          align="flex-start"
          gap={4}
          borderRight="1px solid"
          borderColor="border.default"
          px={6}
        >
          <Flex direction="column" py={8} gap={4} w="100%">
            <Heading size="lg">Settings</Heading>
            <SettingsNavigation />
          </Flex>
        </Flex>
        <Flex
          className="SettingsContainer__Content"
          flex="1 1 auto"
          direction="column"
          gap={0}
          align="stretch"
          overflow="auto"
          py={8}
          px={10}
          pb="140px"
        >
          <Outlet />
        </Flex>
      </Flex>
    </Flex>
  );
}
